export function isMapFullscreenSidebarModalOpen() {
  // Check if the DOM element is present and not already submitted
  return Boolean(document.querySelector('.d-map-fullscreen-sidebar-modal:not([data-map-fullscreen-modal-submitted])'));
}
